/** Synthetic field for TanStack Table row identity (API may repeat aiOutboundCallRecordUuid). */
export const AI_CALL_LOG_TABLE_ROW_KEY = "_aiCallLogTableRowKey";

/**
 * @param {Array<Record<string, unknown>> | undefined} rows
 * @returns {Array<Record<string, unknown>>}
 */
export function withAiCallLogTableRowKeys(rows) {
  if (!rows?.length) return [];
  return rows.map((r, index) => ({
    ...r,
    /** Duplicate of `aiCallSid` so we can show Call SID + Listen in separate columns with unique accessors. */
    callSid: r.aiCallSid ?? r.polyaiCallSid ?? null,
    [AI_CALL_LOG_TABLE_ROW_KEY]: [
      r.aiOutboundCallRecordUuid,
      r.callGroupUuid,
      r.aiCallSid ?? r.polyaiCallSid ?? "null",
      index,
    ].join("|"),
  }));
}
